module.exports = __webpack_public_path__ + "static/media/add-circle-white.23bb8903.svg";